import {AfterViewInit, Component, ElementRef, EventEmitter, NgZone, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import { AssignmentService } from 'src/app/shared/services/assignment.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Utils } from 'src/app/shared/utils/utils';
import { catchError, debounceTime } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { UserService } from 'src/app/shared/services/user.service';
import { Input } from '@angular/core';
import { GlobalConstants } from '../global-constants';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { BaseService } from 'src/app/shared/services';
import { ActivatedRoute, Router } from '@angular/router';
import { IWGSharedService } from '../../shared/services/shared.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, AfterViewInit {

  loading = false;
  start: string;
  end: string;
  selectedServiceName = '';
  USAssignmentFormat = false;
  USEORAssignmentFormat = false;
  assignmentLabel = '';
  assignmentLabelPlural = '';
  summary: any;
  items: any;
  totalRecords = 0;
  dataSource: any;
  selectedSummaryItem: any;
  selectedTabIndex = 0;

  JobTitleLabel = 'Job Title';
  WorkerLabel = 'Worker';
  showRates = true;
  ComplianceFormat = false;
  timer:any;

  // MatPaginator navigation
  pageEvent: PageEvent;

  @ViewChild(MatPaginator, { static : false} ) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('wrapper1') wrapper1: ElementRef<any>;
  @ViewChild('wrapper2') wrapper2: ElementRef<any>;

  @ViewChild('div1') div1: ElementRef<any>;
  @ViewChild('div2') div2: ElementRef<any>;
  @ViewChild('listTable') listTable: any;

  @Input() service: number;
  @Input() state: any;
  selected:any="";
  selectedState:any="";
  @Input() overrideListFilters: any;

  @Output() dateChange: EventEmitter<MatDatepickerInputEvent<any>>;

  displayedColumns: string[] = [];

  listColumns: string[];

  // Map to avoid default sorting by MatTable for column name and orderby passing value are same.
  sortColMap = {'IDCol': 'ID', 'DisplayID': 'ID', 'WorkerLabel': 'Worker', 'ManagerName': 'Manager', 
                  'CountryName': 'Country', 'RecommendationLabel': 'Recommendation', 'RecommendationDate': 'EvaluationDate', 
                  'HoursLabel': 'Hours', 'ExpensesLabel': 'Expenses', 'PayRateLabel': 'PayRate', 'ProjectAmountLabel': 'ProjectAmount',
                  'EndClientsLabel': 'EndClients', 'InvoiceDateLabel': 'InvoiceDate', 'ServiceLabel': 'Service',
                  'Region': 'States', 'QuoteIDLabel': 'QuoteID', 'TitleLabel': 'Title', 'JobTitleLabel': 'JobTitle',
                  'DateRequestedLabel': 'DateRequested', 'ClientMarkupLabel': 'ClientMarkup', 'CandidateLabel': 'Candidate',
                  'ClientLabel': 'Client', 'TotalInEngagement': 'TotalInEngagmentCurrency', 'StatusLabel': 'Status', 
                  'InvoiceTitle': 'Title', 'EndClientLabel': 'EndClientName','StatesLabel':'States',
                  'SalesDisplayID':'DisplayID', 'SalesTaxLabel': 'SalesTax','MarkupLabel':'Markup','SalesEndClientLabel': 'EndClient',
                  'CreatedByLabel':'CreatedBy','CreationDateLabel':'CreationDate'
                }

                constructor(public factoryService: BaseService, public utils: Utils, public renderer: Renderer2,
                  public userService: UserService,  public zone: NgZone, public sharedService?: IWGSharedService) { 
    
                    if(this.sharedService){
                    this.sharedService.isStateChange.subscribe((data) => {                      
                      if (data == null || !data) {return; }
                      this.getItems();
                      this.sharedService.isStateChange.next(false);                     
                    });
                    }    
                  }    

  ngOnInit(): void {
    // Set state on first load
    
    this.selectedTabIndex = this.state.global_scope - 1;
    this.selected = this.state.country;
    this.selectedState = this.state.state;
    
    this.state.start = this.convertStringToDate(this.state.start);
    this.state.end = this.convertStringToDate(this.state.end);
    if(!this.state.order) {
      this.state.order = 'asc';
    }
  }

  setTopScroll(): void {
    this.zone.onStable.pipe(debounceTime(300)).subscribe(() => {
      this.renderer.setStyle(this.div1.nativeElement, 'width', (this.listTable._elementRef.nativeElement.clientWidth) + 'px');
      this.wrapper1.nativeElement.onscroll = e => {
        this.renderer.setStyle(this.div1.nativeElement, 'width', (this.listTable._elementRef.nativeElement.clientWidth ) + 'px');
        this.wrapper2.nativeElement.scroll((e.target as HTMLElement).scrollLeft, 0);
      }
      this.wrapper2.nativeElement.onscroll = e => {
        this.renderer.setStyle(this.div1.nativeElement, 'width', (this.listTable._elementRef.nativeElement.clientWidth ) + 'px');
        this.wrapper1.nativeElement.scroll((e.target as HTMLElement).scrollLeft, 0);
      };
    });
  }

  ngAfterViewInit(): void {
    // this._cd.detach();
    this.setTopScroll();
  }

  getItems = (noLimit = false) => {
    this.loading = true;
    let limit;

    if (noLimit === true) {
      limit = 0;
    } else {
      limit = this.state.limit || 25;
    }

    let params = {
      limit
    };

    // Add dynamic summary item filters
    if (this.selectedSummaryItem) {
      // alert(this.selectedSummaryItem.FilterValue);
      if (this.state.service === 2 && this.selectedSummaryItem.FilterValue === 9) {
        // AOR does not have the filter option 9 so need to change for all..
        params[this.selectedSummaryItem.FilterName] = 0;
      } else {
        params[this.selectedSummaryItem.FilterName] = this.selectedSummaryItem.FilterValue;
      }
    }

    // Add quote reference when looking up assignments
    if (this.state.quoteId) {
      params["quote_id"] = this.state.quoteId;
    }

    // Add assignmentId when looking up documents
    if (this.state.assignmentId) {
      params["assignment_id"] = this.state.assignmentId;
    }

    // Override filters in case we don't ever want to send a particular param. E.g. we don't want to send service
    // param when querying for invoices.
    if (this.overrideListFilters) {
        params = Object.assign({}, params, this.overrideListFilters);
    }

    // if (this.itemsRequest) {
    //     this.itemsRequest.$cancelRequest();
    // }

    const datePipe = new DatePipe('en-US');
    let searchStart = this.state.start;
    let searchEnd = this.state.end;

    searchStart = this.convertStringToDate(this.state.start);
    searchEnd = this.convertStringToDate(this.state.end);

    
    let selectedCountry = null;
    if (this.state.country && this.state.country != -1) {
        if(this.state.country.Abbreviation) {
          selectedCountry = this.state.country.Abbreviation;
        } else {
          selectedCountry = this.state.country;
        }
    }

    let selectedStateAPI = null;
    if (this.state.state && this.state.state != -1) {
        if(this.state.state.Abbreviation) {
          selectedStateAPI = this.state.state.Abbreviation;
        } else {
          selectedStateAPI = this.state.state;
        }
    }

    const defaultParams = {
      limit: this.state.limit,
      page: this.state.page,
      // start: datePipe.transform(this.state.start, 'yyyy-MM-ddTh:mm:ssz'),
      // end: datePipe.transform(this.state.end, 'yyyy-MM-dd'),
      start: searchStart ? searchStart.toISOString() : '',
      end: searchEnd ? searchEnd.toISOString() : '',
      global_scope: this.state.global_scope,
      service: this.state.service,
      // to show ALL text, the value of All option need to have some value, got set it as -1 in country-select component
      country: selectedCountry,
      state: selectedStateAPI,
      q: this.state.q ? this.state.q.trim(): null,
      order_by: this.getSortColName(this.state.order_by),
      order: this.state.order
    };

    params = Object.assign({}, defaultParams, params);

    const prom = this.factoryService.getItems(params).pipe(catchError((err) => {
      console.log('There was an error getting data in component', err);
      throw (err);
    }))
      .subscribe(result => {
        if (result.apiCallStatus && result.data.Data) {
          this.items = result.data.Data.objects;
          this.dataSource = new MatTableDataSource<any>(this.items);
          this.totalRecords = result.data.Data.total;
          if (this.paginator) {
            this.paginator.length = result.data.Data.total;
            this.paginator.pageIndex = result.data.Data.page - 1;  
          }
          this.dataSource.sort = this.sort;

          if (result.data.Data.Summary) {
            this.summary = result.data.Data.Summary.SummaryItems;
            // // eee calling back into derived class
            // if (this.updateLabels != null)
            // {
            //     this.updateLabels();
            // }

            // Preselect summary filter
            if (!this.selectedSummaryItem && this.summary) {
              this.selectedSummaryItem = this.summary[0];
            }
          }
          this.setTopScroll();
        }
        // this.router.navigate(
        //   [], 
        //   {
        //     relativeTo: this.route,
        //     queryParams: this.state, 
        //     queryParamsHandling: 'merge', // remove to replace all query params by provided
        //   });
        this.loading = false;
      },
        error => {
          this.loading = false;
          console.log(error);
        });
  }

  convertStringToDate(dateVal) {
    if(typeof(dateVal) == "string"){
      return new Date(dateVal);
    } else {
      return dateVal;
    }
  }

  setStateParams(): void {
    const defaultRange = this.utils.getDefaultDateRange(
      GlobalConstants.getScopeName(this.state.global_scope));

    if (!this.state.start) {
      this.state.start = defaultRange.start;
    }

    if (!this.state.end) {
      this.state.end = defaultRange.end;
    }
    //IWG-2619 - removed default search filter on page load
    if (this.state.q) {
      this.state.q = '';
    }

    // if (this.allowDefaultParams && this.allowToChangeParams) {
    //             // To ignore the previous state params while listing the documents list
    //             this.state.q = '';
    //             this.state.page = 1;
    //             this.state.limit = 25;
    //             this.state.order_by = '';
    //             this.state.order = 'asc';
    //             this.allowToChangeParams = false; // To block the next request to override.
    //         }

    this.handleGlobalScopeChange();

    this.selectedServiceName = this.utils.getServiceName(this.state.service);

    if (this.selectedServiceName === 'Employer of Record') {
      this.assignmentLabel = 'Assignment';
    } else if (this.selectedServiceName === 'Agent of Record') {
      this.assignmentLabel = 'Engagement';
    } else if (this.selectedServiceName === 'Compliance') {
      this.assignmentLabel = 'Evaluation';
    }
    this.assignmentLabelPlural = this.assignmentLabel + 's';
  }


  removeColFromDisplay(contentVal): void {
    const index: number = this.displayedColumns.indexOf(contentVal);
    if (index !== -1) {
      this.displayedColumns.splice(index, 1);
    }
  }

  changeSummary(summaryItem): void {
    this.state.page = 1;
    this.selectedSummaryItem = summaryItem;
    this.getItems();
  }

  generateListColumns(): void {
    this.displayedColumns = [...this.listColumns];
    // Function needs to be override in child components.
  }

  onTabChanged($event): void {
    if (this.state.global_scope == 3 || $event.index == 2) { // if swicthing between US and international (or all), drop the country filter.
      this.state.country = -1;
      this.state.state = "-1";
    }
    this.state.global_scope = ($event.index) + 1;
    this.state.page = 1;

    // this code block is not needed as it is taken care in generateListColumns method of invoice.component 
    //hide/show logic for showing payement dates on non-US invoices
    // $scope.ShowPaymentDate = true;
    //if ($scope.USEORDisabled != true && ctrl.state.global_scope != 2 )
    // if (ctrl.state.global_scope != 2 )
    // {
    //     $scope.ShowPaymentDate = false;
    // } 

    this.utils.setSessionFilter(GlobalConstants.getScopeName(this.state.global_scope),
      { start: this.state.start, end: this.state.end });
    this.handleGlobalScopeChange();
    this.generateListColumns();
    this.getItems();
  }

  onSearchChange(searchText): void {
    this.state.q = searchText;
    clearTimeout(this.timer);
    const time = 1000;
    this.timer = setTimeout(() => {
      this.state.page = 1;
      this.getItems();
    }, time);
    
  }

  handleCountryChange(country): void {
    this.state.country = country;
    this.state.page = 1;
    this.getItems();
  }

  handleStateChange(state): void {   
    this.state.state = state;
    this.state.page = 1;
    this.getItems();
  }

  handleDateChange(date): void {
    if (this.state.start.getTime() <= this.state.end.getTime()) 
    {
      this.utils.setSessionFilter(GlobalConstants.getScopeName(this.state.global_scope),
      { start: this.state.start, end: this.state.end });
      this.state.page = 1;
      this.getItems();
    }
  }

  naviatePageTo(event?: PageEvent): void {
    this.state.page = event.pageIndex + 1;
    this.state.limit = event.pageSize;
    this.getItems();
  }

  handleGlobalScopeChange(): void {
    if (this.state.global_scope === 3) {
      this.USAssignmentFormat = true;
    }
    else {
      this.USAssignmentFormat = false;
    }

    if (this.state.global_scope === 3 && this.service === 1) {
      this.USEORAssignmentFormat = true;
      // this.state.countryId = 231;
      // this.countryId = 231;
    }
    else {
      this.USEORAssignmentFormat = false;
      // this.state.countryId = 0;
      // this.countryId = 0;
    }
  }

  updateLabels = () => {
    this.JobTitleLabel = 'Job Title';
    this.WorkerLabel = 'Worker';
    this.showRates = true;

    // Must set this to an int or else we get double postbacks
    // this.state.service = $stateParams.service || 1;
    this.state.service = (this.state.service || 1);

    if (this.service === 2) {
      this.showRates = false; // hide for AOR
      this.JobTitleLabel = 'Service Type';
      this.WorkerLabel = 'Contractor';
      this.ComplianceFormat = false;
    } else if (this.service === 3) {
      this.showRates = false; // hide for AOR
      this.JobTitleLabel = 'Service Type';
      this.WorkerLabel = 'Contractor';
      this.ComplianceFormat = true;
    }
  }

  archive = (id) => {
    this.updateRequest(id, {archived: true} );
  }

  unarchive = (id) => {
    this.updateRequest(id, {archived: false} );
  }
  delete = (id) => {
    this.deleteRequest(id);
  }

  updateRequest = (id, updateParams) => {
    this.loading = true;
    this.factoryService.update(id, updateParams).pipe(catchError((err) => {
      throw (err);
      }))
      .subscribe(returnVal => {
        this.getItems();
        this.loading = false;
      },
          error => {
              // ctrl.loading = false;

              this.loading = false;
              console.log(error);
          });
  }
  deleteRequest = (id) => {
    this.loading = true;
    this.factoryService.delete(id).pipe(catchError((err) => {
      throw (err);
      }))
      .subscribe(returnVal => {
        this.getItems();
        this.loading = false;
      },
          error => {
              this.loading = false;
              console.log(error);
          });
  }

  sortData(sort: Sort): void {
    const isAsc = sort.direction === 'asc';
    
    this.state.order_by = sort.active;
    this.state.order = sort.direction;
    this.getItems();
  }

  getSortColName(sort: string) {
    if(this.sortColMap[sort]) {
      return this.sortColMap[sort];
    } else {
      return sort;
    }
  }


}
